import { useEffect, useContext } from 'react';
import { initTaboolaPush } from '../../utils/taboola-push';
import ABeagleContext from '../../contexts/abeagle';

/**
 * Hook to initialize Taboola push notifications
 * - Runs on client-side only (useEffect)
 * - Uses feature flag for eligibility and emergency killswitch
 *
 * @param {Object} buzz - The buzz/article data object
 */
export function useTaboolaPush(buzz) {
  const { experiments, getFeatureFlagValue } = useContext(ABeagleContext);

  useEffect(() => {
    if (!experiments.loaded) return;
    // Initialize Taboola push notifications once experiment data is available.
    initTaboolaPush(buzz, getFeatureFlagValue).catch((err) => {
      console.error('[useTaboolaPush] Initialization error:', err);
    });
  }, [buzz, getFeatureFlagValue, experiments.loaded]);
}
